import { Redirect } from '@reach/router';
import React from 'react';

import { store } from 'index';
import { parse } from 'query-string';
import { getRedirectToLoginPath } from 'utils/happyFunctions';

function protectedRoute(
  Component: React.ComponentType<any>,
  reasonForLogin?: string
) {
  return (props: any) => {
    const parsed: any = parse(window.location!.search);
    const isLoggedIn: boolean = store.getState().thisUser.isLoggedIn;
    if (isLoggedIn || parsed.tt) {
      return <Component {...props} />;
    }
    return (
      <Redirect noThrow={true} to={getRedirectToLoginPath(reasonForLogin)} />
    );
  };
}

export default protectedRoute;
